/* eslint-disable import/prefer-default-export */

import {
  Message, TwilioMessage, TwilioMessageAttributes, TwilioUser, User,
} from './types';
import { determineReachabilityStatus } from './utils';

export const toTwilioMessage = (message: Message): TwilioMessage => {
  const {
    sid: id,
    author,
    body,
    index,
    dateCreated,
    attributes,
  } = message;
  return {
    id,
    author,
    body,
    index,
    dateCreated,
    attributes: (attributes as TwilioMessageAttributes),
  };
};

export const toTwilioUser = ({
  identity,
  friendlyName,
  attributes,
  isOnline,
}: User, isSelf): TwilioUser => ({
  id: identity,
  name: friendlyName ?? '',
  tag: attributes?.userTag ?? null,
  description: attributes?.userDescription ?? null,
  exhibitorBoothId: attributes?.boothId ?? null,
  email: attributes?.email ?? null,
  role: attributes?.role ?? 'attendee',
  reachabilityStatus: determineReachabilityStatus(isOnline, attributes?.isIdle ?? false),
  isSelf,
});
